import instances from './instances';

export const getLocaleFromUrl = (
  url: string,
  curInstance: string,
): string | undefined => {
  const instanceFound = instances.find(
    (inst) => inst.instanceName === curInstance,
  );

  return url.includes('/en')
    ? instanceFound?.languages[0]
    : instanceFound?.languages[1];
};
